// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","373":"e971612a","453":"component---src-pages-404-tsx","889":"component---src-pages-winners-tsx"}[chunkId] + "-" + {"245":"e0187518d6713221f0b8","373":"d138c23a028c057de37b","453":"0556b4d16c1230420a7a","889":"005434be409e10b4a63a"}[chunkId] + ".js";
};